export const FeatureCheckmarkTransparent = () => {

    return (    
        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="28" height="28" rx="14" fill="rgba(255, 255, 255, 0.05)"/>
            <rect x="6" y="6" width="16" height="16" rx="8" fill="#4CBC18"/>
            <path d="M10.666 14L12.9913 16.558C13.0038 16.5717 13.0191 16.5827 13.0361 16.5903C13.0531 16.5978 13.0714 16.6017 13.09 16.6017C13.1086 16.6017 13.127 16.5978 13.144 16.5903C13.161 16.5827 13.1762 16.5717 13.1887 16.558L17.3327 12" stroke="white" strokeLinecap="round"/>
        </svg>
    )
}